export default __webpack_public_path__ + "static/media/prepare_for_leg_hold.64ee2395.mp3";